import { Inbox } from 'lucide-react';
import type { ReactNode } from 'react';
import styles from './EmptyState.module.css';

export const EmptyState = ({
  title,
  description,
  action,
  icon,
}: {
  title: string;
  description?: string | undefined;
  action?: ReactNode;
  icon?: ReactNode;
}) => (
  <div className={styles['empty']}>
    <span className={styles['icon']} aria-hidden="true">
      {icon ?? <Inbox size={24} />}
    </span>
    <h2 className={styles['title']}>{title}</h2>
    {description ? <p className={styles['description']}>{description}</p> : null}
    {action}
  </div>
);
